import { useEffect } from 'react'
import { useAppState, useAppDispatch } from './Context'
import { TabPanel, useTabs } from 'react-headless-tabs'
import TabSelector from './components/TabSelector'
import { CalculatorIcon } from './components/Icons'

export default function Calculator({ type }) {
  const { name, tabs, ...rest } = require(`./calculators/${type}`).default
  const [selectedTab, setSelectedTab] = useTabs(tabs)
  const dispatch = useAppDispatch()
  const { fields, values } = useAppState()

  useEffect(() => {
    if ('fields' in rest) {
      const values = rest.fields
        .filter((field) => field.type !== 'header')
        .reduce((values, field) => {
          values[field.name] = field.value ?? 0

          return values
        }, {})

      dispatch({ type: 'setValues', payload: values })
      dispatch({ type: 'setFields', payload: rest.fields })
    }
  }, [])

  const handleTabChange = (tab) => {
    if (typeof selectedTab.beforeTabChange === 'function') {
      if (selectedTab.beforeTabChange(dispatch, fields, values)) {
        setSelectedTab(tab)
      }
    } else {
      setSelectedTab(tab)
    }
  }

  return (
    <>
      <div className="flex items-center py-4 font-semibold border-b border-gray-300 md:text-lg">
        <CalculatorIcon className="flex-shrink-0 mr-3 w-5" />
        {name}
      </div>

      <ul className="flex items-center space-x-2 border-b border-gray-300 md:space-x-4">
        {tabs.map((tab) => (
          <TabSelector key={tab.name} isActive={selectedTab === tab} onClick={() => handleTabChange(tab)}>
            {tab.name}
          </TabSelector>
        ))}
      </ul>

      <div className="overflow-scroll overflow-scroll-touch h-[60vh]">
        {tabs.map((tab) => {
          const Component = tab.component

          return (
            <TabPanel key={tab.name} hidden={selectedTab !== tab} className="text-sm">
              <Component />
            </TabPanel>
          )
        })}
      </div>
    </>
  )
}
